import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    show: Boolean,
    submitMode: String
  }

  connect() {
    if (this.showValue) {
      $(this.element).modal({ closable: false }).modal("show")
    }
  }

  force() {
    window.dispatchEvent(new CustomEvent("force-save", {
      detail: { submitMode: this.submitModeValue }
    }))
    $(this.element).modal("hide")
  }

  cancel() {
    window.location.reload()
  }
}
